<template>


<!--    <q-field-->
<!--        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"-->
<!--        v-model="fieldValue"-->
<!--        :label="field.layout_injected_label ? field.layout_injected_label : field.label"-->
<!--        -->
<!--        lazy-rules-->
<!--        debounce="1000"-->
<!--        unmasked-value-->
<!--        :rules="field.required ? [ val => val && val.length > 0 || 'Please type something'] : []"-->
<!--    >-->
    <q-field
      :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"
      v-model="fieldValue"
      :label="field.layout_injected_label ? field.layout_injected_label : field.label"

      lazy-rules
      debounce="1000"
      :rules="field.required ? [ val => val && val > 0 || requiredText] : []"
    >
      <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">
        <money3-component :id="id" class="q-field__input text-left" :model-value="modelValue" @update:model-value="emitValue" v-bind="moneyFormatForComponent" v-show="floatingLabel" />
      </template>
<!--      <template v-slot:control="{ id, floatingLabel, modelValue, emitValue }">-->
<!--        <input :id="id" class="q-field__input text-left" :value="modelValue" @change="e => emitValue(e.target.value)" v-money="moneyFormatForDirective" v-show="floatingLabel">-->
<!--      </template>-->
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
      </q-field>


</template>

<script>

import { Money3Component } from 'v-money3'
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  components: {Money3Component, OptionalLabel},
  data() {
    return {
      moneyFormatForComponent: {
        decimal: '.',
        thousands: ',',
        prefix: '$ ',
        suffix: '',
        precision:0,
        masked: false,
        allowBlank: true,
        minimumNumberOfCharacters: 0,
        disableNegative: true,
      }
    };
  },
  emits: ['update:modelValue'],
  methods: {

  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'Please type amount';
    },
    fieldValue: {
      get() {
        return this.modelValue ? this.modelValue : "";
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
